var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.518 12.84A1.613 1.613 0 017.001 15a1.61 1.61 0 01-1.61-1.613c0-.536.26-1.011.664-1.305l-.01-.027L2.374 1.12H.56A.56.56 0 01.56 0h2.176c.154 0 .294.062.396.164.058.051.11.116.154.208l.964 2.84 13.206-.017c.499 0 .533.359.434.622l-.444 1.39c-.206.643-.42 1.254-.626 1.873l-.926 2.788c-.099.297-.15.646-.502.724a3.64 3.64 0 01-.554.028l-8.077-.004.335 1.162h6.926a1.61 1.61 0 11-1.517 1.063H8.518z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketIcon);
export default __webpack_public_path__ + "static/media/basket-icon.27d4e8739fe949aa872222c49d30da73.svg";
export { ForwardRef as ReactComponent };